import { Grid, Paper, Button } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import CB from '../controls/form/CB';
import LangTB from '../controls/form/LangTB';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Redirect } from 'react-router-dom';
import WYSIWYG from '../controls/form/Wysiwyg';
import Comm from '../comm/comm';
import Tools from '../tools/tools';
import { useRecoilState } from 'recoil';
import ToastMessageAtom from '../atoms/ToastMessageAtom';


const WebPage = (props) => {
    const [title, setTitle] = useState({ bg: "", en: "" });
    const [active, setActive] = useState(true);
    const [lang, setLang] = useState("bg");
    const [html, setHtml] = useState({ bg: "", en: "" });
    const [, setSuccess] = useRecoilState(ToastMessageAtom);

    const [back, setBack] = useState(false);

    const setHtmlByLang = (val) => {
        html[lang] = val;
        setHtml(JSON.parse(JSON.stringify(html)));
    }

    const langChange = (evt, lng) => {
        setLang(lng || lang);
    }


    const titleChange = (val) => {
        title[lang] = val;
        setTitle({ ...title });
    }

    const save = () => {
        Comm.Instance().post("page", {
            "title": title,
            "content": html,
            "active": active,
            "id": props.match.params.pageid
        }).then(r => {
            setSuccess({ message: "Данните бяха успешно записани", type: "success" });
            setBack(true)
        })
    }

    const load = () => {
        if (props.match.params.pageid) {
            Comm.Instance().get(`page/${props.match.params.pageid}`).then(
                r => {
                    setTitle(r.data.title);
                    setActive(r.data.active);
                    r.data.content.bg = Tools.fixLinksToFiles(r.data.content.bg);
                    r.data.content.en = Tools.fixLinksToFiles(r.data.content.en);

                    setHtml(r.data.content);
                }
            )
        }

    }


    useEffect(() => load(), []);


    if (back) {
        return <Redirect to="/Pages"></Redirect>
    }
    return (
        <div className="container">
            <Paper>

                <Grid container spacing={3}>
                    <Grid item xs={10}>
                        <Button onClick={() => setBack(true)}><ArrowBackIcon></ArrowBackIcon></Button>
                        <Button onClick={() => save()}><SaveIcon></SaveIcon></Button>
                    </Grid>
                    <Grid item xs={2}>
                        <ToggleButtonGroup
                            value={lang}
                            exclusive
                            onChange={langChange}
                        >
                            <ToggleButton value="bg" aria-label="left aligned">
                                БГ
                            </ToggleButton>
                            <ToggleButton value="en" aria-label="left aligned">
                                EN
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>

                    <Grid item xs={8}>
                        <LangTB label="Заглавие" value={title[lang]} change={(v) => titleChange(v)} lang={lang}></LangTB>
                    </Grid>
                    <Grid item xs={2}>
                        <CB checked={active} change={(v) => setActive(v)} label="Активна"></CB>
                    </Grid>
                    <Grid item xs={12}>
                        <WYSIWYG value={html[lang]} setValue={setHtmlByLang}></WYSIWYG>

                    </Grid>

                </Grid>

            </Paper>
        </div>
    )
}

export default WebPage;